/**
 * DevExtreme (esm/__internal/ui/popup/m_popup.full.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import "../../../ui/toolbar";
import registerComponent from "../../../core/component_registrator";
import {
    extend
} from "../../../core/utils/extend";
import Popup from "../../../ui/popup/ui.popup";
export default class PopupFull extends Popup {
    _getDefaultOptions() {
        return extend(super._getDefaultOptions(), {
            preventScrollEvents: false
        })
    }
    _getToolbarName() {
        return "dxToolbar"
    }
}
PopupFull.defaultOptions = function(rule) {
    Popup.defaultOptions(rule)
};
registerComponent("dxPopup", PopupFull);
